import * as React from 'react';
import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-[38px] w-full min-w-0 rounded-[var(--r-md)] border border-[var(--border)]',
        'bg-[var(--bg-elevated)] px-3 text-[14px] text-[var(--fg)]',
        'placeholder:text-[var(--fg-faint)]',
        'transition-[border-color,box-shadow] duration-[120ms]',
        'outline-none',
        'focus-visible:border-[var(--ev-accent)] focus-visible:shadow-[var(--shadow-focus)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--fg)]',
        'aria-invalid:border-[var(--ev-error)] aria-invalid:shadow-[0_0_0_3px_rgba(214,69,69,0.28)]',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
